export default __webpack_public_path__ + "static/media/Quarteto-de-cordas2.631120a3.mp3";